import React from 'react'

export default function StockInInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .table-po-container {
          display: flex;
          border: solid 1px lightgrey;
          flex-direction: column; /* Necessary for Firefox browser */
          justify-content: stretch;
          font-size: 0.65em;
        }
        .title-header {
          display: flex;
        }
        .title-header:hover {
          cursor: pointer;
        }
        .title-header div {
          flex: 2;
        }
        .title-header span {
          text-align: right;
        }
        .status-red { color: red; }
        .status-blue { color: blue; }

        .po-checkbox {
          margin-top: 11px;
          margin-left: 12px;
        }
      `}
      </style>
    </React.Fragment>
  )
}
